export enum AuthError {
    MISSING_EMAIL = 'auth/missing-email',
    MISSING_PASSWORD = 'auth/missing-password',
    INVALID_EMAIL = 'auth/invalid-email',
    WRONG_PASSWORD = 'auth/wrong-password',
    USER_NOT_FOUND = 'auth/user-not-found',
    TOO_MANY_REQUESTS = 'auth/too-many-requests',
    USER_MISMATCH = 'auth/user-mismatch',
    EMAIL_ALREADY_IN_USE = 'auth/email-already-in-use',
    WEAK_PASSWORD = 'auth/weak-password',
    PASSWORDS_DONT_MATCH = 'auth/passwords-dont-match',
    UNKNOWN_ERROR = 'auth/unknown-error',
}
